import mockAccountingReportsData from "../../data/mockData/accountingReportsData";
import { types } from "./action";

const initialState = {
  seed: mockAccountingReportsData,
  tableRowResults: [],
  created: [],
  accountedEarnings: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ACCOUNTING_REPORTS:
      return {
        ...state,
        tableRowResults: Array.isArray(action.payload)
          ? action.payload
          : state.tableRowResults,
      };
    case types.ADD_ACCOUNTING_REPORT: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      const exists = state.created.some(r => String(r.id) === String(row.id));
      if (exists) {
        return state;
      }
      return {
        ...state,
        created: [...state.created, row],
      };
    }
    case types.MARK_ACCOUNTED_EARNINGS: {
      const keys = Array.isArray(action.payload)
        ? action.payload.map(String).filter(Boolean)
        : [];
      if (!keys.length) {
        return state;
      }
      return {
        ...state,
        accountedEarnings: Array.from(
          new Set([...state.accountedEarnings, ...keys]),
        ),
      };
    }
    default:
      return state;
  }
};
